import { useState } from "react";
import './ExhibitionsGallery.css'

import useMeta from '../../../hooks/useMeta';

import Navbar from "../../../CommonComponent/Navbar/Navbar";
import Footer from "../../../CommonComponent/Footer/footer";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";

import { useParams } from "react-router-dom";

import { ExhibitionsGalleryIMAGES } from "../ExhibitionsGallery_Data";


const ExhibitionsGallery = () => {
    const { ExhibitionsID } = useParams();

    const ExhibitionsImages = ExhibitionsGalleryIMAGES[ExhibitionsID]?.images || null;

    const page_title = ExhibitionsGalleryIMAGES[ExhibitionsID]?.pg_title || null;

    const page_description = ExhibitionsGalleryIMAGES[ExhibitionsID]?.pg_des || null;

    const [previewImage, setPreviewImage] = useState(null);


    const Meta_title = ExhibitionsGalleryIMAGES[ExhibitionsID]?.Meta_title || null;

    const Meta_OG_description = ExhibitionsGalleryIMAGES[ExhibitionsID]?.Meta_OG_description || null;

    const canonical_OG_url = ExhibitionsGalleryIMAGES[ExhibitionsID]?.canonical_OG_url || null;


    useMeta({
        title: Meta_title,
        description: Meta_OG_description,
        canonical: canonical_OG_url,
        og: {
            locale: 'en_US',
            type: 'article',
            title: page_title,
            description:
                Meta_OG_description,
            url: canonical_OG_url,
            site_name: 'Marvel Blinds',
        },
    });

    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="ExhibitionsGallery_pg_wrapper">
                <div className="ExhibitionsGallery_pg_container">
                    {page_title && (
                        <div className="Page-Main_Dec ExhibitionsGallery_devider">
                            <h1 className="Page-title_LowerCase">{page_title}</h1>
                            <p className="Exhibition_pg_des">{page_description}</p>
                        </div>
                    )}
                    <div className="ExhibitionsGallery_pg_content">
                        <div className="ExhibitionsGallery_grid">
                            {ExhibitionsImages.map((src, index) => (
                                <div
                                    className="Exhibitions_image_card"
                                    id={`img_card_${index}`}
                                    key={index}
                                    onClick={() => setPreviewImage(src)}
                                >
                                    <img
                                        src={src}
                                        alt={`gallery-${index}`}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Preview modal */}
            {previewImage && (
                <div className="Exhibitions_image_overlay" onClick={() => setPreviewImage(null)}>
                    <div className="Exhibitions_image_preview" onClick={(e) => e.stopPropagation()}>
                        <button
                            className="Exhibitions_image_preview_close"
                            onClick={() => setPreviewImage(null)}
                        >
                            ✖
                        </button>
                        <img src={previewImage} alt="preview" className="Exhibitions_image" />
                    </div>
                </div>
            )}
            <Footer />
        </>
    );
};

export default ExhibitionsGallery;
